/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TranscriptInputs */

const en_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript`)
};

const fr_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript`)
};

const it_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стенограмма`)
};

const es_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字稿`)
};

const ja_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプト`)
};

const hi_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_transcript = /** @type {(inputs: TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript = /** @type {((inputs?: TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript(inputs)
	if (locale === "de") return de_transcript(inputs)
	if (locale === "it") return it_transcript(inputs)
	if (locale === "ru") return ru_transcript(inputs)
	if (locale === "es") return es_transcript(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript(inputs)
	if (locale === "ja") return ja_transcript(inputs)
	if (locale === "hi") return hi_transcript(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript(inputs)
	return en_transcript(inputs)
});